import { getUA } from 'react-device-detect';

export const IMAGE_ROOT = `${process.env.REACT_APP_BASE_S3_IMAGE}/app`;

// s3 아이콘
export const ICON_PATH = `${process.env.REACT_APP_BASE_S3_IMAGE}/app/icons`;

// 웹뷰 체크
export const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
  getUA,
);
export const isAndWebView = !!window.binder;

// 앱 유무
export const IS_MARTGO_APP = navigator.userAgent.indexOf('_mcoupon') > -1;

// 전단 웹/모바일 구분
export const IS_LEAFLET_TYPE =
  process.env.REACT_APP_LEAFLET_TYPE === 'APP' ? true : false;

// 운영 체크
export const IS_PROD = process.env.REACT_APP_TYPE === 'PROD' ? true : false;

// 전단 URL 체크
export const LEAFLET_URL_CHECK = (url: string): boolean => {
  if (url.includes('mlotte.net')) {
    return true;
  } else {
    return false;
  }
};